import { Button, Card } from "@common/components";
import { Table } from "@mantine/core";
import { useProjects } from "@requests/project/project";
import { Skeleton } from "@synqup/ui";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Plus } from "tabler-icons-react";

import { useUser } from "../../../contexts/UserContext";
import { ProjectRow } from "../../projects/components/ProjectRow";

export const RecentProjects: React.FC = () => {
  const { starred, mutateStarred } = useUser();
  const { data, mutate } = useProjects({
    recent: true,
    dir: "DESC",
    limit: 6,
  });

  // Fetch projects on mount
  useEffect(() => {
    if (!data) return;
    mutate().catch();
    mutateStarred().catch();
  }, []);

  return (
    <Card
      variant="outlined"
      className="p-6 border-none"
      data-quick-assist-id="recent-projects-1"
    >
      <div className="w-full flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 mb-6">
        <h2 className="text-3xl">Projects</h2>

        <Link
          to="/projects/create"
          data-testid="create-project"
          data-quick-assist-id="create-project"
        >
          <Button leftIcon={<Plus className="w-5 h-5" />}>
            Create project
          </Button>
        </Link>
      </div>

      {data ? (
        data.data.length > 0 ? (
          <div className="rounded overflow-hidden bg-dark-800  -mx-6 lg:mx-0">
            <Table className="w-full">
              <tbody>
                {starred.map((project) => (
                  <ProjectRow key={project.id} project={project} />
                ))}
                {data.data
                  .filter(
                    (project) => !starred.some((p) => p.id === project.id)
                  )
                  .map((project) => (
                    <ProjectRow
                      data-testid="project-card"
                      key={project.id}
                      project={project}
                    />
                  ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <div className="text-center col-span-3 py-6">
            <p>No recent projects...</p>
            <Link to="/projects/create">
              <Button data-testid="create-project" variant="light">
                Create a project
              </Button>
            </Link>
          </div>
        )
      ) : (
        <div className="flex flex-col gap-1">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} visible height={58} />
          ))}
        </div>
      )}

      {data && data.count > 1 && (
        <div className="-mx-6 lg:mx-0">
          <div className="flex justify-end mt-4">
            <Link to="/projects">
              <Button
                variant="light"
                color="dark"
                rightIcon={<ChevronRight className="w-5 h-5" />}
              >
                View more
              </Button>
            </Link>
          </div>
        </div>
      )}
    </Card>
  );
};
